import axios from 'axios'
import baseUrl from './baseUrl';
import store from  '../store';
import { router } from '../router';
//import Vue from 'vue';
import { Toast } from 'vant';

//Vue.use(Toast);
// 创建 axios 实例
let service = axios.create({
  // headers: {'Content-Type': 'application/json'},
  timeout: 60000
})
service.defaults.baseURL = baseUrl
// 设置 post、put 默认 Content-Type
service.defaults.headers.post['Content-Type'] = 'application/json'
service.defaults.headers.put['Content-Type'] = 'application/json'

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers.mobile = 'mobile';
    if (localStorage.getItem('userToken')) {
        config.headers.token = localStorage.getItem('userToken');
    }
    
    if (config.method === 'post' || config.method === 'put') {
        // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
        config.data = JSON.stringify(config.data)
    }
    
    // 请求发送前进行处理
    return config
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error)
  }
)
// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data && response.data.state == '222') {
          Toast(response.data.msg);
          store.commit('changeActiveIndex', 0);
          localStorage.clear();
          window.setTimeout(function(){
            router.push('/login');
          },1000);
          return;
      }
      if (response.data && response.data.state != '200') {

        Toast(response.data.msg);
        //window.alert(response.data.msg);
      }
      return response.data;
    }
  },
  (error) => {
    // window.console.log(error);
    // let info = {},
    // { status, statusText, data } = error.response
    
    // if (!error.response) {
    //   info = {
    //       code: 5000,
    //       msg: 'Network Error'
    //   }
    //   window.console.log(info);
    // } else {
    //   // 此处整理错误信息格式
    //   info = {
    //     code: status,
    //     data: data,
    //     msg: statusText
    //   }
    //   window.alert(status);
    //   window.console.log(info);
    // }
    //window.console.log(error.response);
    
    if (!error.response) {
      
      window.alert("Network Error");
    } else {
      // 此处整理错误信息格式
      
      window.alert(error.response.statusText);
      
    }
  }
)

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function() {
    return service
}